import Joi from 'joi';

export const searchDataArchivalReportSchema = () =>
  Joi.object({
    examYear: Joi.number().required().messages({
      'any.required': 'Exam year is not allowed to be empty.',
    }),
    examLevels: Joi.array().items(Joi.object()).min(1).required().messages({
      'array.min': 'Must select at least one exam level.',
      'any.required': 'Must select at least one exam level.',
    }),
  });
